module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_108-c9ff4c38dacb23e99e0a636341b3c6de.png";